/* PP · Einzelprodukt – Teil „Passend dazu“: Reihe seitlich rollen (Pfeile), Bilder erst laden, wenn der Bereich 300 px vor dem Bildschirm ist
   (spätestens 3 s nach dem Laden) – sonst lädt Chrome sie parallel zum Hauptfoto.
   Wo benutzt: sections/pp-einzel lädt die Datei nur, wenn die Reihe erscheint (pp_passend_zeigen)      Abschaltbar: Zeile in der Einstellung leeren
   Liest: [data-pp-e-band], img[data-pp-src] (snippets/pp-einzel-passend)
   Braucht: Kern pp-einzel-kaufbox.js   Ohne Daten: ohne Reihe tut der Teil nichts
   Schnittstelle: hinterlegt wurzel.__ppTeile.passend – liefert nichts zurück.
   Katalog: shop/baukasten/bausteine.md · Stand: 2026-10-07 (C4 Schritt 5: aus assets/pp-einzel.js, Code der Abschnitte unverändert) */
(function () {
  'use strict';
  var wurzel = document.querySelector('[data-pp-e]');
  if (!wurzel) return;
  // Einrichtung nur hinterlegen – der Kern (pp-einzel-kaufbox.js, lädt danach) ruft sie an der alten Stelle auf und reicht die Helfer (E)
  (wurzel.__ppTeile = wurzel.__ppTeile || {}).passend = function (E) {
    var q = E.q, qa = E.qa;
    // --- 10 · „Passend dazu“: seitlich rollen mit kleinen Pfeilen ---
    qa('[data-pp-e-band]').forEach(function (band) {
      var r = q('[data-pp-e-reihe]', band), l = q('.pp-e__pfeil--links', band), re = q('.pp-e__pfeil--rechts', band);
      function pfeile() { var max = r.scrollWidth - r.clientWidth; l.hidden = r.scrollLeft <= 2; re.hidden = max <= 2 || r.scrollLeft >= max - 2; }
      l.addEventListener('click', function () { r.scrollBy({ left: -r.clientWidth * 0.7, behavior: 'smooth' }); });
      re.addEventListener('click', function () { r.scrollBy({ left: r.clientWidth * 0.7, behavior: 'smooth' }); });
      r.addEventListener('scroll', pfeile, { passive: true });
      window.addEventListener('resize', pfeile);
      window.addEventListener('load', pfeile);
      pfeile();
    });
    // Screening X02 (28.09.2026): Chrome lädt „lazy“-Bilder schon ~1.250 px vor dem Bildschirm – „Passend dazu“ (7 Bilder, ~150 kB) lief so
    // parallel zum Hauptfoto. Jetzt erst, wenn der Bereich 300 px vor dem Bildschirm ist; spätestens 3 s nach dem Laden der Seite (falls der
    // Beobachter nie meldet, z. B. im Hintergrund-Tab) – dann ist das Hauptfoto längst da.
    qa('.pp-e__passend').forEach(function (bereich) {
      var fertig = false;
      function laden() { if (fertig) return; fertig = true; qa('img[data-pp-src]', bereich).forEach(function (i) { i.src = i.getAttribute('data-pp-src'); i.removeAttribute('data-pp-src'); }); }
      if (!('IntersectionObserver' in window)) { laden(); return; }
      var io = new IntersectionObserver(function (es) { for (var k = 0; k < es.length; k++) if (es[k].isIntersecting) { io.disconnect(); laden(); return; } }, { rootMargin: '300px 0px' });
      io.observe(bereich);
      window.addEventListener('load', function () { setTimeout(function () { io.disconnect(); laden(); }, 3000); });
    });
    return {};
  };
})();
